// 입력 제한 정규식
const numberInputRegex = /[^0-9]/gi;
const engInputRegex = /[^a-zA-Z0-9_.]/gi;

// 입력값 제한 적용
const applyInputLimit = (element, regex) => {
  element.addEventListener("focusout", function () {
    let inputValue = element.value;
    if (inputValue.length > 0) {
      if (inputValue.match(regex)) {
        inputValue = inputValue.replace(regex, "");
      }
      element.value = inputValue;
    }
  });

  element.addEventListener("input", function () {
    element.value = element.value.replace(regex, "");
  });
};

export const inputLimitEventHandler = () => {
  const numberElements = document.querySelectorAll(".number");
  numberElements.forEach((element) => applyInputLimit(element, numberInputRegex));

  const engElements = document.querySelectorAll(".eng");
  engElements.forEach((element) => applyInputLimit(element, engInputRegex));
};

export const inputAlertHandler = () => {
  const alertElements = document.querySelectorAll(".alert");
  alertElements.forEach((element) => {
    element.addEventListener("input", () => {
      const inputId = element.id;
      const inputAlert = document.getElementById(`${inputId}Alert`);

      if (element.value === "") {
        inputAlert.classList.remove("d-none");
      } else {
        inputAlert.classList.add("d-none");
      }
    });
  });
}

// 최대 입력 길이 제한 적용
export const inputMaxLengthHandler = (e) => {
  const inputValue = e.target.value;
  const maxLength = e.target.maxLength;
  if (inputValue.length > maxLength) {
    e.target.value = inputValue.slice(0, maxLength);
  }
};